import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { GAService } from '../../services/ga.service';
import { MapService } from '../../services/map.service';
import { PreviewService } from '../../services/preview.service';
import { MapifyMap } from '../../models/MapifyMap';

@Component({
  selector: 'mpf-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss']
})
export class EditorComponent implements OnInit, OnDestroy {
  loading = true;
  map: MapifyMap;
  error: string;
  mapStoreInterval: NodeJS.Timer;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public gaService: GAService,
    public mapService: MapService,
    public previewService: PreviewService
  ) {
    gaService.trackPageView();
  }

  ngOnDestroy() {
    clearInterval(this.mapStoreInterval);
  }

  async ngOnInit() {
    try {
      this.loading = true;

      /**
       * The map restoring priority is
       * 1. URL (digital preview id)
       * 2. localStorage
       * 3. Default map (Amsterdam)
       */
      const digitalPreviewSlug = this.route.snapshot.paramMap.get('digitalPreviewSlug');
      const addToCart = this.route.snapshot.paramMap.get('addToCart');
      const digitalPreviewRequestId = digitalPreviewSlug && digitalPreviewSlug.split('-')[0];

      let map: MapifyMap | null = null;

      if (digitalPreviewRequestId !== null) {
        const digitalPreview = await this.previewService.getDigitalPreviewRequestById(Number(digitalPreviewRequestId));

        map = digitalPreview.map;
      } else {
        const localMapString = localStorage.getItem('map');

        if (localMapString) {
          try {
            map = JSON.parse(localMapString);
          } catch (err) {
            console.error('localMap is corrupted, loading default map...');
          }
        }
      }

      this.map = this.mapService.loadMap(map);
      localStorage.setItem('map', JSON.stringify(this.mapService.toJSON(this.map)));

      // This is a temporal solution to store any map configuration change into localStorage. This way when the user
      // navigates between pages (editor -> checkout -> editor) he/she does not have to start from scratch with the default map.
      // TODO: Persist the map on the server (mongodb, mysql) and improve the logic to detect map changes to be persisted.
      this.mapStoreInterval = setInterval(() => {
        localStorage.setItem('map', JSON.stringify(this.mapService.toJSON(this.map)));
      }, 100);

      if (addToCart) {
        setTimeout(() => {
          // click snipcart button to add item to the cart and redirect page to cart summary!
          const el = document.getElementById('add-to-snip-basket');
          if (el) {
            el.click();
          }
        }, 500);
      }

      this.router.navigate(['create']);

      this.loading = false;
    } catch (err) {
      // if URL map decoding went wrong then navigate to /editor page without encoded map in URL
      // after this the editor will load the map either in the localStorage or the default one.
      this.router.navigate(['create']);
    }
  }
}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/components/editor/editor.component.ts